import React, { useState, useEffect } from 'react';
import EmployeeDataTable from '../EmployeeDataTable/EmployeeDataTable';
import Nav from '../Nav/Nav';
import API from '../../utils/API';
import './EmployeeDataArea.css';
import EmployeeContext from '../../utils/EmployeeContext';

const EmployeeDataArea = () => {
  const [developerState, setDeveloperState] = useState({
    users: [],
    order: 'descend',
    filteredUsers: [],
    headings: [
      { name: 'Image', order: 'descend' },
      { name: 'name', order: 'descend' },
      { name: 'phone', order: 'descend' },
      { name: 'email', order: 'descend' },
      { name: 'location', order: 'descend' }
    ]
  });

  const handleSort = heading => {
    let currentOrder = developerState.headings
      .filter(elem => elem.name === heading)
      .map(elem => elem.order)
      .toString();

    if (currentOrder === 'descend') {
      currentOrder = 'ascend';
    } else {
      currentOrder = 'descend';
    }

    const compareFunction = (a, b) => {
      if (currentOrder === 'ascend') {
        if (a[heading] === undefined) {
          return 1;
        } else if (b[heading] === undefined) {
          return -1;
        }
        else if (heading === 'name') {
          return a[heading].first.localeCompare(b[heading].first);
        } else if (heading === 'location') {
          return a[heading].city - b[heading].city;
        } else {
          return a[heading].localeCompare(b[heading]);
        }
      } else {
        if (a[heading] === undefined) {
          return 1;
        } else if (b[heading] === undefined) {
          return -1;
        }
        else if (heading ==='name') {
          return b[heading].first.localeCompare(a[heading].first);
        }else if (heading === 'location') {
          return b[heading].city - a[heading].city;
        }  else {
          return b[heading].localeCompare(a[heading]);
        }
      }
    };
    const sortedUsers = developerState.filteredUsers.sort(compareFunction);
    const updatedHeadings = developerState.headings.map(elem => {
      elem.order = elem.name === heading ? currentOrder : elem.order;
      return elem;
    });

    setDeveloperState({
      ...developerState,
      filteredUsers: sortedUsers,
      headings: updatedHeadings
    });
  };

  const handleSearchChange = event => {
    const filter = event.target.value;
    const filteredList = developerState.users.filter(item => {
      let values = item.name.first.toLowerCase() + ' ' + item.name.last.toLowerCase();
      console.log(filter, values)
    if(values.indexOf(filter.toLowerCase()) !== -1){
      return item
    };
    });

    setDeveloperState({ ...developerState, filteredUsers: filteredList });
  };

  useEffect(() => {
    API.getUsers().then(results => {
      console.log(results.data.results);
      setDeveloperState({
        ...developerState,
        users: results.data.results,
        filteredUsers: results.data.results
      });
    });
  }, []);

  return (
    <EmployeeContext.Provider
      value={{ developerState, handleSearchChange, handleSort }}
    >
      <Nav />
      <div className='data-area'>
        {developerState.filteredUsers.length > 0 ? <EmployeeDataTable /> : <div></div>}
      </div>
    </EmployeeContext.Provider>
  );
};

export default EmployeeDataArea;
